import React from 'react';
import { Row, Col, Table, Form, Button, Spinner } from 'react-bootstrap';
import Pagination from 'react-js-pagination';
import { useTranslation, Trans } from 'react-i18next';
import { DebounceInput } from 'react-debounce-input';
import { parseDateBR } from 'helpers/date';

const ListingActionsAwaitingPaymentReport = ({
  reports,
  filters,
  stateFilters,
  handleFilterChange,
  returnTable,
  load
}) => {
  const { t } = useTranslation();

  const values = (report) => {
    let count = 0;
    report.values.forEach((value) => {
      count += Number(value.actual_value);
    });
    return count.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  };

  const aging = (report) => {
    let day1 = new Date(report.updated_at);
    let day2 = new Date();
    let time = day2.getTime() - day1.getTime();
    let days = time / (1000 * 3600 * 24);
    return days.toFixed();
  };

  const status = (report) => {
    if (report.status_id == 17) return t('statuses:awaiting_receipt');
    else return t('statuses:awaiting_comprovations');
  };

  const handlePageChange = (page) => handleFilterChange({ page });

  const getTable = () => {
    return (<Table
      bordered
      hover
      responsive
      id="table-to-xls"
      style={{ fontSize: '13px' }}
    >
      <thead>
        <tr>
          <th className="text-center align-middle" scope="col">
            Fabricante
          </th>
          <th className="text-center align-middle" scope="col">
            ID Ação
          </th>
          <th className="text-center align-middle" scope="col">
            Nome da Ação
          </th>
          <th className="text-center align-middle" scope="col">
            Valor
          </th>
          <th className="text-center align-middle" scope="col">
            Desde
          </th>
          <th className="text-center align-middle" scope="col">
            Aging
          </th>
          <th className="text-center align-middle" scope="col">
            Status
          </th>
        </tr>
      </thead>
      <tbody>
        {load?(
          <tr><td colSpan={7} className="text-center">
          <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        </td></tr>
        ):reports.data.map((action, k) =>
          action.status_id === 17 || action.status_id === 18 ? (
            <tr key={k}>
              <td className="text-center align-middle">
                {action.company_name} <b>/</b> {action.company_alias}
              </td>
              <td className="text-center align-middle">
                {action.id}
              </td>
              <td className="text-center align-middle">
                {action.action_name}
              </td>
              <td className="text-center align-middle">
                {values(action)}
              </td>
              <td className="text-center align-middle">
                {parseDateBR(action.updated_at)}
              </td>
              <td className="text-center align-middle">
                {aging(action)} dia(s)
              </td>
              <td className="text-center align-middle">
                {status(action)}
              </td>
            </tr>
          ) : (
            false
          )
        )}
      </tbody>
    </Table>);
  }
  if(returnTable) return getTable();
  return (
    <>
      <Row>
        <Col>
          <Row className="justify-content-end">
            {filters.map((filter, k) => (
              <Col key={k} md={3}>
                <Form.Group>
                  <Form.Label>{t(`label:${filter.name}`)}</Form.Label>
                  <Form.Control
                    value={stateFilters[filter.key]}
                    onChange={(e) =>
                      handleFilterChange({
                        [filter.key]: e.target.value,
                        page: 1,
                      })
                    }
                    as="select"
                  >
                    <option value="">{t('label:all')}</option>
                    {filter.options.map((option, k) => (
                      <option key={k} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            ))}
          </Row>
          <Row>
            <Col md={3}>
              <Form.Group>
                <Form.Label>{t('label:records per page')}:</Form.Label>
                <Form.Control
                  as="select"
                  value={stateFilters.per_page}
                  onChange={(e) =>
                    handleFilterChange({ per_page: e.target.value, page:1 })
                  }
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Status:</Form.Label>
                <Form.Control
                  as="select"
                  value={stateFilters.status_id}
                  onChange={(e) =>{
                    handleFilterChange({ status_id: e.target.value, page:1 })
                  }}
                >
                  <option value={'17,13'}>Todos</option>
                  <option value={17}>{t('statuses:awaiting_receipt')}</option>
                  <option value={13}>
                    {t('statuses:awaiting_comprovations')}
                  </option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label>Aging Minimo:</Form.Label>
                <DebounceInput
                  element={Form.Control}
                  debounceTimeout={500}
                  value={stateFilters.__aging_min}
                  onChange={(e) =>
                    handleFilterChange({ __aging_min: e.target.value, page:1 })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={3} className="ml-auto">
              <Form.Group>
                <Form.Label>{t('label:search')}:</Form.Label>
                <DebounceInput
                  element={Form.Control}
                  debounceTimeout={500}
                  value={stateFilters.__search}
                  onChange={(e) =>
                    handleFilterChange({ __search: e.target.value, page:1 })
                  }
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              {getTable()}
            </Col>
          </Row>
          <Row>
            <Col>
              <Trans i18nKey="label:interpolateShowingRecords">
                Showing {{ from: reports.pagination.from || '0' }} to{' '}
                {{ to: reports.pagination.to || '0' }} from {{ total: reports.pagination.total }}{' '}
                records
              </Trans>
            </Col>
            <Col className="d-flex justify-content-end">
              <Pagination
                activePage={reports.pagination.current_page}
                itemsCountPerPage={reports.pagination.per_page}
                totalItemsCount={reports.pagination.total}
                pageRangeDisplayed={5}
                onChange={handlePageChange}
                itemClass="page-item"
                linkClass="page-link"
                prevPageText="‹"
                nextPageText="›"
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default ListingActionsAwaitingPaymentReport;
